/**
 * Addresses that moved (spec 2026-10-08 piece 2; ADR 0069): an old first segment, and everything under it, opens the
 * same path under the new one. This is the one place in the app the old name stays (the guard,
 * infrastructure/scripts/services-name-guard.test.ts).
 */
export const RENAMED_PATHS: readonly { readonly from: string; readonly to: string }[] = [
  { from: "scheduling", to: "services" },
];

/** The path under the new first segment, or the path unchanged when it is not under the old one. */
export function renamedPath(pathname: string, from: string, to: string): string {
  const old = `/${from}`;
  if (pathname !== old && !pathname.startsWith(`${old}/`)) return pathname;
  return `/${to}${pathname.slice(old.length)}`;
}
